var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStyleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.426,
    height: 79.705,
    viewBox: "0 0 77.426 79.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M527.357,0l39.855,39.855L527.357,79.705h37.571l39.855-39.851L564.928,0Z",
    transform: "translate(-527.357 0)",
    fill: "#dfe0ed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleArrow);
export default __webpack_public_path__ + "static/media/StyleArrow.9f7c3fa069936c079d50257ea161b9fa.svg";
export { ForwardRef as ReactComponent };